<router-outlet></router-outlet>
@if (loaderServiceState) {
    <app-loader [guestLoader]="true" />
}
